// Primary entry — the Container (wires the mock participant helpers →
// KeyStat[] and renders the View). ProgramDetail imports this as
// `ProgramKeyStats`, unchanged (same `program` prop).
export { ProgramKeyStatsContainer as ProgramKeyStats } from "./ProgramKeyStatsContainer";
// The props-only View — for the sim (renders with fixture stats, no mock
// reads). Never imported by ProgramDetail.
export { ProgramKeyStats as ProgramKeyStatsView, type ProgramKeyStatsProps } from "./ProgramKeyStats";
